import React, { ReactElement, useEffect } from 'react';
import { default as Form } from '../../components/connectedForm';
import styled from 'styled-components';
import HeaderContainer from '../connectedForm/HeaderContainer';
import { SecondaryButton } from '../connectedForm/Button';
import { useHistory } from 'react-router';
import { Analytics } from '../../mixpanel';

const Message = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.54);
`;

const Announce = styled.div`
  margin-left: 15px;
`;

type ISection = {
  heading: string;
  body?: string;
  bulletPoints?: string[];
};

export type IHoldingMessageProps = {
  title: string;
  sections: ISection[];
};

export const HoldingMessage = ({ title, sections }: IHoldingMessageProps) => {
  const history = useHistory();

  useEffect(() => {
    Analytics.track(`Viewed unactivated feature: ${title}`);
  }, [title]);

  const renderedSections = sections.map((section, index) => {
    const renderedPoints: ReactElement[] = [];
    if (section.bulletPoints) {
      section.bulletPoints.map((point, index) => {
        renderedPoints.push(<li key={point}>{point}</li>);
      });
    }

    return (
      <Message key={`section_${section.heading}`}>
        <h1>{section.heading}</h1>
        {section.body}
        <ul>{renderedPoints}</ul>
      </Message>
    );
  });

  return (
    <>
      <HeaderContainer>
        <Form.HeaderTitle value={title} />
        <Form.HeaderAction>
          <SecondaryButton onClick={() => history.goBack()}>Back</SecondaryButton>
        </Form.HeaderAction>
      </HeaderContainer>
      <Announce>
        <Form.Fieldset cols={1}>
          <Form.Legend label="Activation" />
          <Message>
            <h1>{title} functionality is not currently activated on your system</h1>
            To register your interest in this functionality, please{' '}
            <a style={{ display: 'inline' }} href={'mailto:softwaresupport@ogl.co.uk'}>
              contact the Profit4 Support team
            </a>
            .
          </Message>
          {renderedSections.length > 0 ? (
            <>
              <Form.Legend label="Information" />
              {renderedSections}
            </>
          ) : null}
        </Form.Fieldset>
      </Announce>
    </>
  );
};
